import $ from 'jquery';
import {isMobile} from '../utilities';

class Nav {
  constructor(element){
    this.$el = $(element);
    this.headerWrapper = document.querySelector(".header-wrapper");
    this.initialHeight = parseInt(this.$el.css('height'));
    this.navMinHeight = parseInt(this.$el.css('min-height'));
    !this.isHomepage() ? this.$el.addClass('alt') : '';
    this.checkScroll();
    this.$el.find('.nav-menu>li').hover(this.hoverEnter, this.hoverExit.bind(this) );
    $('.open-mobile-nav-btn').on('click', this.activateNav.bind(this));
    $(window).on('scroll', this.checkScroll.bind(this));
    $(window).on('resize', this.resetNavHeight.bind(this));
    this.headerHeightUnit();
    window.addEventListener('alertBanner', function() {
      setTimeout(function() {
        document.documentElement.style.setProperty("--headerHeight",`${document.querySelector(".header-wrapper").offsetHeight - 1}px`);
      }, 10);
    });
  }

  activateNav(){
    this.$el.toggleClass('mobile-active');
  }

  checkScroll() {
    if(!isMobile()){
      let windowScrollPosition = $(window).scrollTop();
      let heightOffset = this.initialHeight - windowScrollPosition;

      this.$el.css({'height':heightOffset + 'px'});
      if(heightOffset <= this.navMinHeight) {
        this.$el.addClass('pegged');
        this.isHomepage() ? this.$el.addClass('alt') : '';
      } else {
        this.$el.removeClass('pegged');
        this.isHomepage() ? this.$el.removeClass('alt') : '';
      }
    }
  }

  headerHeightUnit() {
    document.documentElement.style.setProperty("--headerHeight",`${this.headerWrapper.offsetHeight - 1}px`);
  };

  resetNavHeight(){
    if(this.$el.hasClass('pegged')){
      this.$el.css({'height': '0px'});
    } else {
      this.$el.css({'height': '10.83333vw'});
    }
    if(isMobile()) {
      this.isHomepage() ? this.$el.removeClass('alt') : '';
    } else {
      $('.header-component').removeClass('mobile-active');
    }
    this.$el.removeAttr('style');
    this.$el.removeClass('pegged');
    this.initialHeight = parseInt(this.$el.css('height'));
    this.navMinHeight = parseInt(this.$el.css('min-height'));
    this.headerHeightUnit();
  }

  isHomepage(){
    return this.$el.parent().find('.home').length > 0;
  }

  hoverEnter() {
    !isMobile() ? $('.header-component').addClass('alt') : '';
  }

  hoverExit(){
    if(!$('.header-component').hasClass('pegged') && this.isHomepage()){
      $('.header-component').removeClass('alt');
    }
  }

}

$('.header-component').each((index, element)=>{
  new Nav(element);
});
